import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from 'qs'
//接口url枚举
enum StatisticalEnumApi{
  CHECK_DIFF_PAGE = '/check/diff/query',
  CHECK_DIFF_AUDIT = '/check/diff/audit'

}
//盘点差异表 --- 查询
export function getCheckDiffPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_DIFF_PAGE}?${qs.stringify(data)}`,
    data
  })
}

//盘点差异表 --- 审核
export function auditCheckDiffPage(data: {OrderNo: string}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_DIFF_AUDIT,
    data
  })
}


